const CatalogArticles = () =>
  import(
    "@/features/dep/payments/presentation/catalogs/views/ArticlesListView"
  );
const CatalogConcepts = () =>
  import(
    "@/features/dep/payments/presentation/catalogs/views/ConceptsListView"
  );
const ConfigurationPaymentsList = () =>
  import(
    "@/features/dep/payments/presentation/configuration/views/ConfigurationListView"
  );
const ManagementStore = () =>
  import("@/features/dep/management_store/views/ManagementListScreen");
const PaymentsListForm = () =>
  import("@/features/dep/payments/presentation/list/views/PaymentsListScreen");
const ScholarShipsListForm = () =>
  import(
    "@/features/dep/payments/presentation/catalogs/views/ScholarshipListView"
  );

const ConciliationsView = () =>
  import(
    "@/features/dep/payments/presentation/conciliation/views/ConciliationView"
  );

export const depPaymentRoutes = [
  {
    path: "/payments/catalogs/concepts",
    component: CatalogConcepts,
  },
  {
    path: "/payments/catalogs/articles",
    component: CatalogArticles,
  },
  {
    path: "/payments/settings",
    component: ConfigurationPaymentsList,
  },
  {
    path: "/payments/store",
    component: ManagementStore,
  },
  {
    path: "/payments/list",
    component: PaymentsListForm,
  },
  {
    path: "/payments/loans",
    component: ScholarShipsListForm,
  },
  {
    path: "/payments/conciliation",
    component: ConciliationsView,
  },
];
